import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  setAffId, setOfferId, setReturnUrl, setSourceId, setPartnerId, setIsBookingMetadataInited, setUtmSource,
} from '../../../../../ui-kitchen/src/reducers/resyRouterSlice';

const useCaptureBookingMetadataOnInit = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const affId = searchParams.get('affId');
    const offerId = searchParams.get('offerId');
    const sourceId = searchParams.get('src');
    const utmSource = searchParams.get('utm_source');
    const partnerId = searchParams.get('partnerId');
    const returnUrl = searchParams.get('returnUrl');
    if (affId) {
      dispatch(setAffId(affId));
    }
    if (offerId) {
      dispatch(setOfferId(offerId));
    }
    if (sourceId) {
      dispatch(setSourceId(sourceId));
    }
    if (utmSource) {
      dispatch(setUtmSource(utmSource));
    }
    if (partnerId) {
      dispatch(setPartnerId(partnerId));
    }
    if (returnUrl) {
      dispatch(setReturnUrl(returnUrl));
    }
    dispatch(setIsBookingMetadataInited(true));
  }, []);
};

// eslint-disable-next-line import/prefer-default-export
export { useCaptureBookingMetadataOnInit };
